import React from 'react';
import { AppLayout, SpaceBetween } from '@amzn/awsui-components-react';

import { UserCard, GroupCard, DebugCard } from 'modules/preferences/components';

export function UserPreferences() {
    const Content = () => {
        return (
            <SpaceBetween size="l">
                <UserCard />
                <GroupCard />
                {process.env.NODE_ENV !== 'production' && <DebugCard />}
            </SpaceBetween>
        );
    };
    return <AppLayout content={<Content />} toolsHide={true} navigationHide={true} headerSelector="#merp-nav" />;
}
